import { lazy } from 'react';

/**
 * Роутер модуля форм
 */

const FormListPage = lazy(() => import('./pages/list'));
const FormDetailPage = lazy(() => import('./pages/details'));
const FormBuilderPage = lazy(() => import('./pages/builder_v1'));

export const formsRoutes = {
    path: 'forms',
    children: [
        { element: <FormListPage />, index: true },
        { path: 'new', element: <FormBuilderPage /> },
        { path: ':fid', element: <FormDetailPage /> },
        { path: ':fid/edit', element: <FormBuilderPage /> },
    ],
};
